import React from 'react';
import Img from 'react-image';
import styled, { keyframes } from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import { ImgClick } from '../../utility';
import { useSelector } from 'react-redux';
import soundShooting from '../sounds/play-shooting.mp3';
import soundShootingFailed from '../sounds/play-shooting-failed.mp3';
import AnimationWithSound from '../AnimationWithSound';
import { useEffect } from 'react';
import { set } from 'lodash-es';

export const PLAYER_LAMP_ARSENAL_STATE = {
  NOT_DISPLAYED: 0,
  DISPLAY: 1,
  FIGHTING: 2,
  SHOOT: 3,
  NOT_SHOOT: 4,
};

const PlayerLampArsenal = ({ handleOnClick, state, onShootCompleted }) => {
  const config = useSelector((state) => state.config);
  const { images } = useImagesContext();
  const [ownState, setOwnState] = React.useState([state]);

  useEffect(() => {
    if (
      state === PLAYER_LAMP_ARSENAL_STATE.SHOOT ||
      state === PLAYER_LAMP_ARSENAL_STATE.NOT_SHOOT
    ) {
      setOwnState((v) => [...v, state]);
      setTimeout(() => {
        setOwnState([state]);
      }, 1000);
    } else {
      setOwnState([state]);
    }
  }, [state]);

  return (
    <>
      {ownState.includes(PLAYER_LAMP_ARSENAL_STATE.DISPLAY) && (
        <FullScreenImage src={images['play-left-gun.png']} />
      )}
      {ownState.includes(PLAYER_LAMP_ARSENAL_STATE.FIGHTING) && (
        <>
          <FullScreenImage src={images['play-left-gun.png']} />
          <LampLeftButton
            src={images['play-lamp-left.png']}
            onClick={() => {
              console.debug('Lamp Left button clicked');
              handleOnClick();
            }}
          />
        </>
      )}
      {ownState.includes(PLAYER_LAMP_ARSENAL_STATE.SHOOT) && (
        <AnimationWithSound
          imageUrl={images['play-player-shooting.png']}
          soundFile={soundShooting}
          playSound={!config.isMutedSound}
          onSoundEnd={onShootCompleted}
        />
      )}
      {ownState.includes(PLAYER_LAMP_ARSENAL_STATE.NOT_SHOOT) && (
        <AnimationWithSound
          imageUrl={images['play-player-shooting-failed.png']}
          soundFile={soundShootingFailed}
          playSound={!config.isMutedSound}
          onSoundEnd={onShootCompleted}
        />
      )}
    </>
  );
};

const FullScreenImage = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 0;
`;

const LampLeftButton = styled(ImgClick)`
  position: absolute;
  left: 21px;
  top: 261px;
  z-index: 1;
`;

export default PlayerLampArsenal;
